import React from 'react';
import PropTypes from 'prop-types';
import './Pagination.css';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div className="th-pagination">
      <ul>
        {/* Previous button */}
        <li>
          <button
            onClick={() => onPageChange(currentPage - 1)}
            className="pagination-arrow"
            disabled={currentPage === 0}
          >
            <i className="fas fa-angle-left"></i>
          </button>
        </li>

        {/* Page numbers */}
        {[...Array(Math.max(1, totalPages))].map((_, index) => (
          <li key={index}>
            <button
              className={currentPage === index ? 'active' : ''}
              onClick={() => onPageChange(index)}
            >
              {index + 1}
            </button>
          </li>
        ))}

        {/* Next button */}
        <li>
          <button
            onClick={() => onPageChange(currentPage + 1)}
            className="pagination-arrow"
            disabled={currentPage >= totalPages - 1}
          >
            <i className="fas fa-angle-right"></i>
          </button>
        </li>
      </ul>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
